import {Component} from '@angular/core';
//import {ROUTER_DIRECTIVES, Router} from '@angular/router-deprecated';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'navigation',
  //  directives: [ROUTER_DIRECTIVES],
    templateUrl: "./navigation.html",
	styles: [require("./navigation.scss")]
})

export class NavigationComponent {

    private currentRouteName:string = "";
    constructor(private route: ActivatedRoute){

    }

}



// WEBPACK FOOTER //
// ./src/app/components/navigation-components/navigation.component.ts